import Livesearch from 'adeliom-livesearch-js';
import 'adeliom-livesearch-js/dist/livesearch.css';

const livesearchPath = document.querySelector('meta[name="livesearch-path"]');

const getLivesearchPath = () => {
    return livesearchPath.getAttribute('content');
};

if (livesearchPath) {
    const settings = {
        pathAjax: getLivesearchPath(),
        submitSelector: '',
        minimumTimeLoading: 1000,
        paramsInUrl: true,
        animationScrollTo: 'smooth',
        pageKey: 'page',
        handleArraysNatively: true,
        displayFirstPageInUrl: false,
        useAnimate: false,
    };

    const livesearch = new Livesearch(settings);

    const updatePlaceholer = () => {
        const filtersGroup = document.querySelectorAll('[data-key]');

        filtersGroup.forEach((filterGroup) => {
            const inputs = filterGroup.querySelectorAll('input');
            let placeholdersArray = [];
            inputs.forEach((activeInput) => {
                if (activeInput.checked) {
                    placeholdersArray.push(
                        activeInput.nextElementSibling.textContent,
                    );
                }
            });
            const placeholder = filterGroup.querySelector('[data-placeholder]');
            if (placeholdersArray.length) {
                placeholder.innerHTML = placeholdersArray.join(', ');
            } else {
                placeholder.innerHTML = placeholder.dataset.placeholder;
            }
        });
    };

    const disableInput = () => {
        const filtersGroup = document.querySelectorAll('[data-key]');
        filtersGroup.forEach((filterGroup) => {
            const inputs = filterGroup.querySelectorAll('input');
            inputs.forEach((activeInput) => {
                if (activeInput.checked) {
                    filtersGroup.forEach((filter) => {
                        if (
                            filter.getAttribute('data-key') !=
                            filterGroup.getAttribute('data-key')
                        ) {
                            const disabledFilters =
                                filter.querySelectorAll('input');
                            disabledFilters.forEach((disabledFiler) => {
                                disabledFiler.setAttribute('disabled', '');
                            });
                        }
                    });
                }
            });
        });
    };

    const activeInput = () => {
        const disabledInputs = document.querySelectorAll('input:disabled');
        disabledInputs.forEach((disabledInput) => {
            disabledInput.removeAttribute('disabled');
        });
    };

    livesearch.on('beforeChange', () => {
        handlePinnedPost();
        updatePlaceholer();
        disableInput();
        document
            .querySelector('[js-livesearch-loading]')
            .classList.remove('hidden');
        document
            .querySelector('[js-livesearch-results]')
            .classList.add('hidden');
    });

    livesearch.on('afterChange', (datas) => {
        activeInput();
        document
            .querySelector('[js-livesearch-results]')
            .classList.remove('hidden');
        document
            .querySelector('[js-livesearch-loading]')
            .classList.add('hidden');

        if (datas.results.filters) {
            Object.keys(datas.results.filters).forEach((filterKey) => {
                const selectFilters = document.querySelectorAll(
                    "form [data-filters='" + filterKey + "']",
                );

                selectFilters.forEach((selectFilter) => {
                    const filters =
                        selectFilter.querySelectorAll('.js-filter-item');
                    let nbVisible = 0;
                    filters.forEach((filter) => {
                        const values = datas.results.filters[filterKey].values;

                        const filterId = filter
                            .querySelector('input')
                            .getAttribute('data-id');

                        if (!values[filterId]) {
                            filter.classList.add('hidden');
                        } else {
                            filter.classList.remove('hidden');
                            nbVisible++;
                        }
                    });
                    if (nbVisible !== 0) {
                        selectFilter.classList.remove('hidden');
                    }
                });
            });
        }
    });

    //Reset Form
    let resetBtn = document.querySelectorAll('.reset');
    Array.from(resetBtn).forEach((button) => {
        button.addEventListener('click', () => {
            livesearch.reset();
        });
    });

    //Hide or display pinned post
    // eslint-disable-next-line no-inner-declarations
    function handlePinnedPost() {
        let checkboxes = document.querySelectorAll('input[type="checkbox"]');
        let anyChecked = Array.from(checkboxes).some(function(checkbox) {
            return checkbox.checked;
        });
        let pinnedPost = document.querySelector('.pinned');
        if(pinnedPost) {
            if (anyChecked) {
                pinnedPost.classList.add('hidden');
            } else {
                pinnedPost.classList.remove('hidden');
            }
        }
    }

    livesearch.init();
    updatePlaceholer();
}
